// @ts-expect-error untyped dependency
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import FormattedMessage from 'I18n/components/FormattedMessage';
import emptyFunction from 'react-utils/emptyFunction';
import { AbstractTextElement } from 'foundations-components/transitional/components/AbstractTextElement';
import { Small } from 'foundations-components/transitional/components/Small';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Link } from 'foundations-components/transitional/components/Link';
import { List } from 'foundations-components/transitional/components/List';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AssetProviderProfile({
  onTrackInteraction = emptyFunction,
  providerAvatarSize = 48,
  providerWebsiteAnalyticsId,
  provider,
  use = 'default'
}) {
  const MetadataText = props => {
    if (use === 'sidebar') {
      return /*#__PURE__*/_jsx(Small, {
        children: props.children
      });
    }
    return /*#__PURE__*/_jsx(AbstractTextElement, {
      children: props.children
    });
  };
  const {
    avatarUrl,
    location,
    name,
    websiteUrl
  } = provider;
  return /*#__PURE__*/_jsxs(MediaObject, {
    align: "center",
    itemLeft: /*#__PURE__*/_jsx("div", {
      style: {
        width: providerAvatarSize
      },
      children: /*#__PURE__*/_jsx(UIAvatar, {
        size: "responsive",
        src: avatarUrl,
        type: "contact"
      })
    }),
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-100",
      marginBlockEnd: use === 'default' ? '200' : '0',
      children: name
    }), /*#__PURE__*/_jsxs(List, {
      inline: true,
      use: "inline-divided",
      wrapChildren: true,
      children: [use === 'default' && location && /*#__PURE__*/_jsx(MetadataText, {
        children: location
      }), /*#__PURE__*/_jsx(MetadataText, {
        children: /*#__PURE__*/_jsx(Link, {
          "data-hs-analytics-id": providerWebsiteAnalyticsId,
          external: true,
          href: websiteUrl,
          onClick: () => onTrackInteraction('click provider link'),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-assets-core.details.providerInfo.website"
          })
        })
      })]
    })]
  });
}